<template>
  <div class="crud_form_wrapper">
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_branch") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #233076">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameAr')"
            v-model.trim="data.name_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.nameEn')"
            v-model.trim="data.name_en"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.addressAr')"
            v-model.trim="data.address_ar"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.addressEn')"
            v-model.trim="data.address_en"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.time')"
            v-model.trim="data.time"
            required
          />
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.link_google_map')"
            v-model.trim="data.link_google_map"
          />

          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "EditBranch",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        name_ar: null,
        name_en: null,
        address_ar: null,
        address_en: null,
        phone: null,
        time: null,
        link_google_map: null,
      },
    };
  },

  methods: {
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },

    async getDataToEdit() {
      try {
        const res = await this.$axios({
          method: "GET",
          url: `branches/${this.$route.params.id}`,
        });
        const item = res.data?.data?.Branch || {};
        this.data.name_ar = item.name_ar;
        this.data.name_en = item.name_en;
        this.data.address_ar = item.address_ar;
        this.data.address_en = item.address_en;
        this.data.phone = item.phone;
        this.data.time = item.time;
        this.data.link_google_map = item.link_google_map;
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to load branch"
        );
      }
    },

    async submitForm() {
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("name[ar]", this.data.name_ar || "");
      REQUEST_DATA.append("name[en]", this.data.name_en || "");
      REQUEST_DATA.append("address[ar]", this.data.address_ar || "");
      REQUEST_DATA.append("address[en]", this.data.address_en || "");
      REQUEST_DATA.append("phone", this.data.phone || "");
      REQUEST_DATA.append("time", this.data.time || "");
      REQUEST_DATA.append("link_google_map", this.data.link_google_map || "");
      REQUEST_DATA.append("_method", "PUT");

      try {
        await this.$axios({
          method: "POST",
          url: `branches/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/branches/all" });
      } catch (error) {
        this.$message.error(
          error?.response?.data?.message || "Failed to edit branch"
        );
      } finally {
        this.isWaitingRequest = false;
      }
    },
  },

  created() {
    this.getDataToEdit();
  },
};
</script>
